import {createAction} from 'redux-actions';

import ActionTypes from './action-types';

export default {
    fetchMealTypes: createAction(ActionTypes.MEAL_TYPE_FETCH, (institutionId, childId) => ({institutionId, childId})),
    fetchMealTypesSuccess: createAction(ActionTypes.MEAL_TYPE_FETCH_SUCCESS, (institutionId, mealTypes) => ({
        institutionId,
        mealTypes,
    })),
    fetchMealTypesFailed: createAction(ActionTypes.MEAL_TYPE_FETCH_FAILED, (institutionId, error) => ({
        institutionId,
        error,
    })),
    updateMealTypes: createAction(ActionTypes.MEAL_TYPE_UPDATE, (institutionId, mealTypes) => ({
        institutionId,
        mealTypes,
    })),
    updateMealTypesSuccess: createAction(ActionTypes.MEAL_TYPE_UPDATE_SUCCESS, (institutionId, mealTypes) => ({
        institutionId,
        mealTypes,
    })),
    updateMealTypesFailed: createAction(ActionTypes.MEAL_TYPE_UPDATE_FAILED, (institutionId, error) => ({
        institutionId,
        error,
    })),
};
